import React from 'react';
import { Link } from 'react-router';

import { Trans } from 'react-i18next';

import { useCreateUrl } from '../../../hooks/useNavigate';
import { Text } from '@datanomik/core-ui';
interface OfflineInstitutionsProps {
  id?: string;
  description?: string;
}

export const OfflineInstitutions = ({ id, description }: OfflineInstitutionsProps) => {
  const createUrl = useCreateUrl();

  return (
    <>
      <Text>
        <Trans i18nKey="We are experiencing some connection instability with {{description}}.">
          We are experiencing some connection instability with
          {' '}
          {{ description }}
          .
        </Trans>
      </Text>
      <Text>
        <Trans
          i18nKey="Please check out the last update. We are sorry for the inconvenience."
        >
          Please check out the
          {' '}
          <Link className="dn-ramove-margin" to={createUrl('/links', { institutionId: id })}>
            last update
          </Link>
          . We are sorry for the inconvenience.
        </Trans>
      </Text>
    </>
  );
};
